import { inventoryProductService } from "../../../../../Api/Services/InventoryService/inventoryProduct";
import { ACTION_NAMES, SLICE_NAMES } from "../../../../../constants/action";
import { ERROR_MESSAGES } from "../../../../../constants/error";
import createGenericSlice from "../../../../../utils/reduxUtils/createEntitySlice";
import createServiceAsyncThunk from "../../../../../utils/reduxUtils/createServiceAsyncThunk";
import { IInventoryBrandListResponse } from "../../types";

// Fetch all brands
export const fetchInventoryBrands = createServiceAsyncThunk<
  IInventoryBrandListResponse,
  void
>(
  ACTION_NAMES.FETCH_INVENTORY_BRAND_LIST,
  () => inventoryProductService.getBrands(),
  ERROR_MESSAGES.FETCH_INVENTORY_BRAND_FAILURE
);

export const inventoryBrandSlice = createGenericSlice<
  IInventoryBrandListResponse,
  void
>(
  SLICE_NAMES.INVENTORY_BRAND_LIST_SLICE,
  fetchInventoryBrands
);

export const {
  clearError: clearInventoryBrandError,
  clearSuccessMessage: clearInventoryBrandSuccessMessage,
} = inventoryBrandSlice.actions;

export default inventoryBrandSlice.reducer;
